import React from 'react';
import { View, Text, ScrollView } from 'react-native-web';
import PropTypes from 'prop-types';

import { Spacing } from "../../../components";
import JourneyComponent from "./JourneyComponent";
import Colors from "../../../constants/Colors";

const TagListRender = (props) => {
    const { tagName, journeys } = props;

    if (journeys.length === 0) return null;

    return (
        <View style={{ marginBottom: 8, padding: 12  }}>
            <Text style={{ fontSize: 18, color: Colors.fontColorOnBackground }}>
                { tagName }
            </Text>
            <Spacing height={12} />


            <ScrollView horizontal={true}>

                {
                    journeys.map(item => {
                        return (
                            <JourneyComponent key={item.id.toString()} data={item} />
                        )
                    })
                }

            </ScrollView>

        </View>
    )
}

TagListRender.propTypes = {
    tagName: PropTypes.string.isRequired,
    journeys: PropTypes.array.isRequired,
}

export default TagListRender;
